import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { createAuth0 } from '@auth0/auth0-vue'
import dayjsPlugin from './plugins/dayjs'

// Enhanced logging for debugging
console.log('🚀 Technician App Starting...', {
  timestamp: new Date().toISOString(),
  environment: process.env.NODE_ENV,
  auth0Domain: process.env.VUE_APP_AUTH0_DOMAIN,
  apiUrl: process.env.VUE_APP_API_URL,
  callbackUrl: process.env.VUE_APP_AUTH0_CALLBACK
})

// Create the Vue application
const app = createApp(App)

// Configure Auth0
console.log('🔐 Configuring Auth0...', {
  domain: process.env.VUE_APP_AUTH0_DOMAIN,
  clientId: process.env.VUE_APP_AUTH0_CLIENT_ID?.substring(0, 8) + '...',
  audience: process.env.VUE_APP_AUTH0_AUDIENCE
})

app.use(
  createAuth0({
    domain: process.env.VUE_APP_AUTH0_DOMAIN,
    clientId: process.env.VUE_APP_AUTH0_CLIENT_ID,
    authorizationParams: {
      redirect_uri: process.env.VUE_APP_AUTH0_CALLBACK,
      audience: process.env.VUE_APP_AUTH0_AUDIENCE
    },
    cacheLocation: 'localstorage',  // Persist auth state across page reloads
    useRefreshTokens: true           // Enable automatic token renewal
  })
)

// Use the router
console.log('🧭 Configuring Vue Router...')
app.use(router)

// Use Day.js plugin
console.log('📅 Configuring Day.js plugin...')
app.use(dayjsPlugin)

// Mount the app
console.log('🎯 Mounting Vue app to #app...')
app.mount('#app')

console.log('✅ Technician App initialized successfully!')